<template>
    <div class="container-fluid" v-if="isDataReady">
        <v-title :breadcrumb="{label: 'Lists', route: {name: 'lists', params: {segmentId}}, root: true}">
            Lists
            <template v-if="!hasNoPermissions" #actions>
                <r-button
                    v-if="hasActiveSegment && activeSegment.data.canDataExport && $auth.$pages['data-exports'].isAllowed"
                    @click="exportData"
                    slot="actions" :class="{'inline-m': hasAddCustomer}">
                    Export to CSV
                </r-button>
                <router-link
                    v-if="hasAddCustomer"
                    :to="{name: 'add-customer'}"
                    class="btn btn-link">Add Customer<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </template>
        </v-title>
        <v-no-content v-if="hasNoPermissions">
            <span slot="title" data-cy="No Permission">You do not have access to list data</span>
            <span slot="description">You currently lack permissions to view the data within lists. Please contact your account administrator if you think this is an error.</span>
        </v-no-content>
        <div class="grid-fitted grid-unstackable" v-else>
            <div class="grid-item segments-column no-flex inline-m" v-show="isColumnOpen">
                <segments-column />
            </div>
            <div class="grid-item">
                <template v-if="activeSegment">
                    <segment-grid />
                </template>
                <template v-else>
                    <div class="tile">
                        <div class="tile-content">
                            <v-no-content slot="no-content">
                                <span slot="title">It seems that you have not selected a Segment</span>
                                <span slot="description">Please select a segment.</span>
                            </v-no-content>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import SegmentsColumn from '@/modules/segments/components/segments-column';
    import SegmentGrid from '@/modules/segments/components/segment-grid';
    import gridColumns from '@/modules/segments/data/grid-columns';
    import vNoContent from '@/components/v-no-content';
    import {mapGetters, mapState, mapActions} from 'vuex';
    import ExportDataSegments from '@/modules/segments/mixins/export-data-segments';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import VIcon from '@/components/form/v-icon';

    export default {
        name: 'lists',
        mixins: [
            ExportDataSegments,
            LoadStateMixin,
        ],
        props: {
            segmentId: String,
            type: String,
            resourceId: String,
        },
        components: {
            VIcon,
            vNoContent,
            vTitle,
            SegmentsColumn,
            SegmentGrid,
        },
        computed: {
            ...mapState('segments', ['activeFilters', 'hasNoPermissions', 'segmentCollection']),
            ...mapGetters({
                segmentCollection: 'segments/segmentCollection',
                activeSegment: 'segments/activeSegment',
                isColumnOpen: 'segments/isSegmentsColumnOpen',
            }),
            hasActiveSegment() {
                return this.activeSegment !== null;
            },
            hasAddCustomer() {
                // it's possible the user has no segments
                return this.hasActiveSegment
                    && this.activeSegment.data.hasCreateCustomerAction
                    && this.$auth.$pages['add-customer'].isAllowed;
            },
            isFilteredView() {
                return !!this.type && !!this.resourceId;
            },
        },
        methods: {
            ...mapActions({
                fetchSegments: 'segments/fetch',
                activateSegmentPage: 'segments/activateSegmentPage',
                setActiveSegmentId: 'segments/setActiveSegmentId',
                createTemporaryLogSegment: 'segments/createTemporaryLogSegment',
            }),
            async fetchData() {
                try {
                    await this.fetchSegments(this.$auth);
                    if (this.isFilteredView) {
                        const {type, resourceId} = this;
                        this.createTemporaryLogSegment({type, resourceId, gridColumns});
                    } else if (this.segmentId) {
                        this.setActiveSegmentId(this.segmentId);
                    } else {
                        this.activateSegmentPage(this.segmentCollection.defaultPageName);
                    }
                } catch (err) {
                    console.error(err);
                }
            },
        },
    };
</script>
